import { ROUTES } from 'src/containers/App/routes';

export const OPTION_LISTS = {
  UNIT: 'unit',
} as const;

export type OptionListKey = (typeof OPTION_LISTS)[keyof typeof OPTION_LISTS];

export const OPTION_LIST_PATHS: Record<OptionListKey, string> = {
  [OPTION_LISTS.UNIT]: 'pricing/simulator/units/list',
};

export const OVERVIEW_PATH = 'pricing/availability/overview';
export const POSITIONS_PATH = 'pricing/availability/positions';
export const PAIRS_PATH = 'pricing/availability/pairs';

export const LIST_PAGE_SIZE = 20;
export const TABLE_PAGE_SIZE = 25;
export const URL_SYNC_DEBOUNCE_MS = 400;

export const STEPS = [
  'all_positions',
  'in_sector',
  'org_position',
  'live_contract',
  'shown_in_booking_form',
  'legal_entity_match',
  'district_bookable',
] as const;

export type StepId = (typeof STEPS)[number];

export const SHOWN_STEP_INDEX = STEPS.indexOf('shown_in_booking_form');

export const POSITION_STATUSES = {
  HIDDEN: 'hidden',
  NOT_SENT: 'not_sent',
  STALE: 'stale',
  ORDERABLE: 'orderable',
} as const;

export type PositionStatus = (typeof POSITION_STATUSES)[keyof typeof POSITION_STATUSES];

export const STATUS_PRIORITY: Record<PositionStatus, number> = {
  not_sent: 0,
  stale: 1,
  hidden: 2,
  orderable: 3,
};

export const STATUS_TAG_COLOR: Record<PositionStatus, 'error' | 'warning' | 'success'> = {
  hidden: 'error',
  not_sent: 'error',
  stale: 'warning',
  orderable: 'success',
};

export const REASON_KINDS = {
  REACHES: 'reaches',
  STALE: 'stale',
  NOT_IN_SCOPE: 'not_in_scope',
} as const;

export const REASON_ORDER = [
  'reaches',
  'stale',
  'not_bookable_in_district',
  'scope_not_live',
  'no_pay_line',
  'zero_rate',
  'no_rate_card',
  'no_engine_version',
  'amendment_later',
  'no_amendment',
  'legacy_contract',
  'legal_entity_differs',
  'not_org_position',
  'not_in_sector',
  'not_in_scope',
] as const;

const SECTORS_ROUTE = '/sectors';
const POSITIONS_ROUTE = '/positions';
const DISTRICTS_ROUTE = '/districts';
export const SECTOR_ROUTE = `${SECTORS_ROUTE}/:id`;
export const DISTRICT_ROUTE = `${DISTRICTS_ROUTE}/:id`;
export const RATE_CARD_ROUTE = `/${ROUTES.RATE_CARDS_VIEW}`;
export const AGENCY_CONTRACTS_ROUTE = `/${ROUTES.AGENCIES_ACTIVE_LIST}`;

export const FIX_ROUTES: Record<string, string> = {
  sectors: SECTORS_ROUTE,
  positions: POSITIONS_ROUTE,
  districts: DISTRICTS_ROUTE,
  legal_entities: `/${ROUTES.LEGAL_ENTITIES}`,
  rate_cards: `/${ROUTES.RATE_CARDS}`,
  rate_engines: `/${ROUTES.RATE_ENGINE_LIST}`,
  agency_contracts: AGENCY_CONTRACTS_ROUTE,
  agency_contract_scope: AGENCY_CONTRACTS_ROUTE,
  agency_contract_amendments: AGENCY_CONTRACTS_ROUTE,
  agency_contract_rate_lines: AGENCY_CONTRACTS_ROUTE,
  agency_contract_rate_lines_pending: AGENCY_CONTRACTS_ROUTE,
};

export const CONTRACT_FIX_TARGETS = ['agency_contracts', 'agency_contract_scope', 'agency_contract_amendments'];
export const CONTRACT_SCOPE_ROUTE = `/${ROUTES.AGENCY_CONTRACT_V2_SCOPE}`;
export const CONTRACT_VIEW_ROUTE = `/${ROUTES.AGENCY_CONTRACT_V2_VIEW}`;
export const CONTRACT_RATE_LINES_TARGETS = ['agency_contract_rate_lines', 'agency_contract_rate_lines_pending'];
export const CONTRACT_RATE_LINES_QUERY = '?tab[]=agencyContractDetails&tab[]=agencyContractRateLines';

export const SHORT_DAY_MONTH_FORMAT = 'D MMM';
export const MS_PER_DAY = 86_400_000;
export const PANEL_SKELETON_HEIGHT = 320;
export const WIDE_LAYOUT_QUERY = '(min-width: 1440px)';
export const FILTERS_COMPACT_WIDTH = 720;
export const FILTERS_STACKED_WIDTH = 560;
